// Facebook CAPI Configuration - Multiple Pixels
export const FACEBOOK_CAPI_CONFIG = {
    API_VERSION: 'v22.0',
    PIXELS: [
        {
            PIXEL_ID: '1374617340295052',
            ACCESS_TOKEN: "EAAPaW5vDmK8BPNtKDrLx5sBw1ZBlxn9k1JiA8aE3dmfiKtBSRLEFubAml1Mo3WT6FqNPbPoD2Ko8f1I7v2l5Qnl2skAwLIhKODAWXJuFozQqFSTv7FNsEvyCxx8lAYwx1zWUkZCjnS2iBuszN0sjsGEdq72O8M2gnu44AE8ZBDkE3OVwpOVepoAwhFeT5cdSQZDZD",
            NAME: 'Primary Pixel'
        },
        {
            PIXEL_ID: '784092551276004',
            ACCESS_TOKEN: "EAALInRyZCY2sBPk1jSD709EncRuSqNQ1LaUKv7XzwSrEq4KVvzOwLlHmhZAlgSZARSxZAKwrzg88pdaAPvYKpzNqricEiLl8HCwgGEyilnZBmMaVZAgsJ7zOiJUcD2VEiPvzIAIqZAnqPIYLvlOiwftkH7mC1bhKauhE1OXGYqsdNKkgt4aSxJ0pY4wCosJnvM9ZAQZDZD",
            NAME: 'Secondary Pixel'
        }
    ],
    getBaseUrl(pixelId) {
        return `https://graph.facebook.com/${this.API_VERSION}/${pixelId}/events`;
    }
};

// Facebook Event Names
export const FACEBOOK_EVENTS = {
    PURCHASE: 'Purchase',
    ADD_TO_CART: 'AddToCart',
    INITIATE_CHECKOUT: 'InitiateCheckout',
    LOGIN: 'Login',
    PAYMENT: 'Payment',
    VIEW_CONTENT: 'ViewContent'
};

// Facebook Event Sources
export const EVENT_SOURCES = {
    WEBSITE: 'website',
    APP: 'app'
};

// Facebook Content Types
export const CONTENT_TYPES = {
    PRODUCT: 'product',
    SUBSCRIPTION: 'subscription'
};

// Default Currency
export const DEFAULT_CURRENCY = 'INR';

// User Data Fields
export const USER_DATA_FIELDS = {
    EMAIL: 'em',
    PHONE: 'ph',
    FIRST_NAME: 'fn',
    LAST_NAME: 'ln',
    DATE_OF_BIRTH: 'db',
    GENDER: 'ge',
    CLIENT_IP: 'client_ip_address',
    CLIENT_USER_AGENT: 'client_user_agent'
};

// Delivery Categories
export const DELIVERY_CATEGORIES = {
    INSTANT: 'instant',
    SCHEDULED: 'scheduled'
};